// FU-03: a pinned campaign-exact filter the driver fact cannot carry — the driver walk is not
// fired (a stripped replay would silently widen to unfiltered totals). Pure presentational;
// the string lives in chartChrome. No Retry — the failure is deterministic. Mirrors
// DimNotApplicableNote's shape.
import { Alert } from '@mui/material'
import { MESSAGES } from '~/components/Charts/chrome/chartChrome'

export function CampaignFilterNote({ metricLabel }: { metricLabel?: string }) {
  return (
    <Alert severity="warning" sx={{ py: 0 }}>
      {MESSAGES.campaignFilterNotApplicable(metricLabel)}
    </Alert>
  )
}
